import React from 'react';

import { HeaderProps } from 'react-table';
import { AlertSeverity } from '@bringg/types';
import { Checkbox } from '@bringg/react-components';

import { Exception } from 'bringg-web/types/common.consts';
import { AntCheckboxToggleRowsSelectedProps } from 'bringg-web/components/bringg-react-table';
import { EXCEPTIONS_COLUMN_IDS } from '../../../consts';
import { AdditionalTextCell, ColumnActionCell, CompanyCell, TeamGroupCell, TeamNameCell } from '../cell-components';
import { AlertOwnerCell } from '../alert-owner/alert-owner-cell';
import { SeverityLabel } from '../../../components/severity-label/severity-label';
import { ALERT_DYNAMIC_COLUMN_IDS } from 'bringg-web/stores/alerts-view/consts';
import type { ColumnWithStrictId, CommonCellProps, ExceptionCellProps } from './column-utils';

// eslint-disable-next-line @typescript-eslint/ban-types
export const sharedColumns: Record<string, ColumnWithStrictId<{}>> = {
	selection: {
		id: EXCEPTIONS_COLUMN_IDS.SELECTION_COLUMN,
		Header: ({ getToggleAllRowsSelectedProps }: HeaderProps<Exception>) => (
			<div className="checkbox-container">
				<Checkbox {...(getToggleAllRowsSelectedProps() as unknown as AntCheckboxToggleRowsSelectedProps)} />
			</div>
		),
		maxWidth: 48,
		Cell: ({ row }: CommonCellProps) => (
			<Checkbox {...(row.getToggleRowSelectedProps() as unknown as AntCheckboxToggleRowsSelectedProps)} />
		),
		disableGlobalFilter: true,
		disableFilters: true,
		disableGroupBy: true,
		disableResizing: true,
		sticky: 'left'
	},
	actions: {
		id: EXCEPTIONS_COLUMN_IDS.ACTIONS,
		maxWidth: 60,
		Cell: ({ row }: CommonCellProps) => (
			<ColumnActionCell alertUuid={row.original.id} ownerId={row.original.owner_id} />
		),
		Header: () => null,
		disableGroupBy: true,
		disableFilters: true,
		disableSortBy: true,
		disableGlobalFilter: true,
		disableResizing: true,
		sticky: 'right'
	},
	team: {
		id: EXCEPTIONS_COLUMN_IDS.TEAM_ID,
		accessor: 'team_id',
		translateKey: 'TEAM',
		// Look for 'getFilterTypes' to see all custom filter options
		filter: 'teamIdWithChildren',
		Cell: ({ value }: CommonCellProps<number>) => <TeamNameCell teamId={value} />,
		// @ts-ignore somehow Group is not a valid field for ReactTable.Column as of 09.03.22
		Group: ({ value, cell, row }: CommonCellProps<number>) => (
			<TeamGroupCell itemsInGroup={row.leafRows.length} teamId={value} cell={cell} />
		)
	},
	alertOwner: {
		id: EXCEPTIONS_COLUMN_IDS.ALERT_OWNER,
		accessor: 'owner_id',
		translateKey: 'ALERT_OWNER',
		filter: 'alertOwners',
		disableSortBy: true,
		Cell: ({ value, row }: CommonCellProps<number>) => (
			<AlertOwnerCell alertOwnerId={value} alertUuid={row.original.id} />
		)
	},
	company: {
		translateKey: 'COMPANY',
		id: EXCEPTIONS_COLUMN_IDS.COMPANY_ID,
		disableSortBy: true,
		filter: 'companies',
		Cell: ({ row }: CommonCellProps<number>) => {
			return <CompanyCell alertId={row.id} />;
		}
	},
	severity: {
		translateKey: 'SEVERITY',
		id: EXCEPTIONS_COLUMN_IDS.SEVERITY,
		filter: 'equals',
		accessor: 'severity',
		Cell: ({ value }: ExceptionCellProps<AlertSeverity>) => <SeverityLabel severityLevel={value} />
	},
	alertAdditionalText: {
		translateKey: 'ADDITIONAL_TEXT',
		id: ALERT_DYNAMIC_COLUMN_IDS.AdditionalText,
		disableSortBy: true,
		disableGlobalFilter: true,
		maxWidth: 300,
		Cell: ({ row }: ExceptionCellProps) => <AdditionalTextCell alertType={row.original.alert_type} />
	}
};
